import React from 'react'
import PropTypes from 'prop-types'
import I18n from 'translations/i18n'
import { connect } from 'react-redux'
import { WorkflowSteps } from 'components/global/atoms'

function handleTitle(employees, value, approvers) {
  const approver = approvers.find((app) => app.key === value)
  if (approver) return approver.name_i18n

  const emp = employees && employees.find((e) => e && parseFloat(e.id) === parseFloat(value))
  if (emp) return emp.name

  return 'loading...'
}

const Step = ({ input: { value }, stepNo, onRemove, workflow_step, employee_all, approvers }) => (
  <WorkflowSteps.Step
    title={handleTitle([...employee_all, ...workflow_step], value, approvers)}
    no={stepNo}
    label={`${I18n.t('step')} ${stepNo}`}
    onRemove={onRemove}
  />
)

Step.propTypes = {
  input: PropTypes.shape(),
  stepNo: PropTypes.number,
  onRemove: PropTypes.func,
  workflow_step: PropTypes.shape(),
  employee_all: PropTypes.arrayOf(Object),
  approvers: PropTypes.arrayOf(Object),
}

const mapStateToProps = ({ employee, workflowDetails }) => ({
  ...employee,
  ...workflowDetails,
})

export default connect(mapStateToProps)(Step)
